import { Tooltip, Typography } from '@mui/material';
import { RiBugLine, RiChatNewLine, RiCloseLine, RiSideBarLine } from '@remixicon/react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSideDrawerState } from 'src/components/containers/SideDrawer';
import { AgButton } from 'src/components/ui';
import { useAiChatStore } from '../store/aiChat.store';
import AiChatIcon from './AiChatIcon';
export default function AiChatDrawerHeader() {
  const toggleHistoryExpanded = useAiChatStore((state) => state.toggleHistoryExpanded);
  const closeDrawer = useSideDrawerState((state) => state.closeDrawer);
  const createNewChat = useAiChatStore((state) => state.reset);
  const debugModeEnabled = useAiChatStore((state) => state.debugModeEnabled);
  const toggleDebugMode = useAiChatStore((state) => state.toggleDebugMode);
  const flags = useFlags();
  const debuggerAllowed = flags.aiChatDebugger;

  return (
    <div className="px-6">
      <div className="flex justify-between w-full">
        <div className="flex gap-1">
          <AgButton variant="ghost" size="icon-sm" shape="circle" onPress={() => toggleHistoryExpanded()}>
            <RiSideBarLine size={20} />
          </AgButton>
          <AgButton variant="ghost" size="icon-sm" shape="circle" onPress={() => createNewChat()}>
            <RiChatNewLine size={20} />
          </AgButton>
          {debuggerAllowed && (
            <Tooltip title={debugModeEnabled ? 'Disable debug mode' : 'Enable debug mode'}>
              <AgButton variant="ghost" size="icon-sm" shape="circle" onPress={toggleDebugMode}>
                <RiBugLine size={20} className={debugModeEnabled ? 'text-brand-6' : ''} />
              </AgButton>
            </Tooltip>
          )}
        </div>
        <div className="flex items-center gap-2">
          <AiChatIcon gradient />
          <Typography
            sx={{
              fontSize: '17px',
              fontWeight: 600,
              backgroundImage: 'linear-gradient(90deg, #64A40A, #91A80E)',
              color: 'transparent',
              backgroundClip: 'text',
            }}
          >
            Agriful Assistant
          </Typography>
        </div>
        <AgButton variant="ghost" onPress={closeDrawer} className="gap-1">
          <RiCloseLine size={18} />
          <p className="leading-none">Close</p>
        </AgButton>
      </div>
    </div>
  );
}
